// extracted by mini-css-extract-plugin
module.exports = {"nickname":"TravellerNameLink_nickname__9ivl7"};